import MaterialReactTable from 'material-react-table'
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { useState, useEffect } from "react";
import {Button} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function ReactTablePopUpSubmitWrapper({
    title,
    columns,
    data,
    onClose,
    onRowSubmit,
    onCSVExport,
    onPDFExport,
    enableExportToolbar = false,
    isLoading = true,
    initialPageSize = 5,
}) {

    const [tableColumns, setTableColumns] = useState([]);

    useEffect(() => {
        // console.log('Useeffect rendered');
        const tableColumns = columns.map(col => {

            let cellAlign = col.align || 'left';
            let columnProperties = {
                accessorKey: col.fieldName,
                header: col.headerName,
                size: col.size,
                minSize: col.minSize || Math.max(col.size || 0, 72),
            };

            if (col.headerName === 'ROW_ACTIONS') {
                columnProperties = {
                    ...columnProperties,
                    header: 'Action',
                    Header: <span style={col.headerStyle}>Action</span>,
                    Cell: ({renderedCellValue,row}) => {
                        // const customerStatus = row.original.customer_status;
                        return (
                            <span>
                                {(
                                    <CheckCircleIcon  onClick={(event) => onRowSubmit(renderedCellValue, event)} 
                                    sx={{
                                        cursor: 'pointer',
                                        color: 'white',
                                        fontSize: '18px',
                                        backgroundColor: 'primary.dark',
                                        margin: '1px',
                                        borderRadius: '12px',
                                        padding: '0px'
                                    }}
                                    />
                                    // <input type="checkbox"  onClick={(event) => onRowSubmit(renderedCellValue, event)}></input>
                                )}
                            </span>
                        );
                    }
                }
                
            } 
            else {

                if (col.headerStyle) {
                    columnProperties = {
                        ...columnProperties,
                        Header: <span style={col.headerStyle}>{col.headerName}</span>
                    };
                }

                columnProperties = {
                    ...columnProperties,
                    Cell: ({renderedCellValue}) => {

                        return (
                            <div style={{textAlign: cellAlign}}>
                                {col.dataStyle ? <span style={col.dataStyle}>{renderedCellValue}</span> : renderedCellValue}
                            </div>
                        
                        );
                    }
                };
            }

            return columnProperties;
        });

        setTableColumns(tableColumns);

    },[columns, onRowSubmit]);

    return (
        <div style={{paddingTop: "10px", paddingBottom: "10px"}}>
            <h1 style={{fontSize: '22px', color: 'darkblue', fontWeight: 'bold', display:'none'}}>{title}</h1>
            <MaterialReactTable
                columns={tableColumns}
                data={data}
                enablePinning
                enableStickyHeader
                enableColumnResizing
                columnResizeMode="onEnd" 
                enableColumnActions={false}
                enableColumnFilters={true}
                enableFilters={true}
                enableGlobalFilter={true}
                enableHiding={true}
                enableFullScreenToggle={true}
                enablePagination={true}
                enableSorting={true}
                enableBottomToolbar={true}
                enableTopToolbar={true}
                muiTableBodyRowProps={{
                    hover: true,
                    sx: {
                      height: '24px',
                    },
                }}
                enableDensityToggle={true}
                defaultColumn={{
                    minSize: 72,
                    size: 110,
                }}
                state={{isLoading: isLoading}}
                muiTableContainerProps={{
                    sx: {
                      overflowX: 'auto',
                      maxWidth: '100%',
                    },
                  }}
                muiTablePaperProps={{
                    elevation: 0,
                    sx: {
                      borderRadius: '0',
                      border: '1px solid #000000',
                    },
                  }}
                muiTableProps={{
                    sx: {
                      width: 'max-content',
                      minWidth: '100%',
                      tableLayout: 'auto',
                    },
                  }}
                  muiTableBodyProps={{
                    sx: () => ({
                      '& tr:nth-of-type(odd)': {
                        backgroundColor:'#bcbfc4',
                      },
                      '& td': {
                        padding: '0 6px !important',
                        fontSize: '12px',
                        lineHeight: 1.1,
                        height: '24px',
                        whiteSpace: 'nowrap',
                        overflow: 'visible',
                      },
                    }),
                  }}
                muiTableHeadCellProps={{
                    sx: {
                      fontWeight: 'bold',
                      fontSize: '12px',
                      lineHeight: 1.2,
                      backgroundColor: '#6e8fec',
                      color:'white',
                      padding: '4px 6px',
                      height: 'auto',
                      whiteSpace: 'normal',
                      overflowWrap: 'break-word',
                      verticalAlign: 'bottom',
                    },
                  }}
                initialState={
                    {
                        density: "compact",
                        showGlobalFilter: false,
                        showColumnFilters: false,
                        pagination: {pageIndex: 0, pageSize: initialPageSize},
                        columnPinning: {  left:['id']}
                    }
                }
                renderTopToolbarCustomActions={
                    () => {
                        if (enableExportToolbar) {
                            return (
                                <span>
                                    <Button color="primary" onClick={onClose}  variant="contained">CLOSE</Button>
                                    <Button color="primary" onClick={onCSVExport} startIcon={<FileDownloadRoundedIcon/>} variant="contained">CSV</Button>
                                    &nbsp;&nbsp;
                                    <Button color="primary" onClick={onPDFExport} startIcon={<FileDownloadRoundedIcon/>} variant="contained">PDF</Button>
                                </span>
                            );
                        }
                        return (<> <Button color="primary" onClick={onClose}  variant="contained">CLOSE</Button></>);
                    }
                }
            />
        </div>
    );
}

export default ReactTablePopUpSubmitWrapper;
